export const TEXTS = {
  PREVIEW: 'Превью',
};
